export function paymentAccountSubmitErrorKey(error: unknown): string {
  const fallback = 'profile.addAccount.submitError';
  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const response = error as { code?: number; status?: number; errorPayload?: unknown; error?: unknown };
  const payload = response.errorPayload ?? response.error;
  if (
    (response.code ?? response.status) === 400 &&
    payload &&
    typeof payload === 'object' &&
    'document_ids' in payload
  ) {
    return 'profile.addAccount.invalidDocumentsError';
  }

  return fallback;
}
